import React from 'react';
import { useTheme } from '@mui/material';

const Leaf = () => {
	const { palette } = useTheme();

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='56'
			height='162'
			viewBox='0 0 56 162'
			fill='none'
		>
			<g
				id='OLiJP logo listek sygnet'
				clipPath='url(#clip0_83_727)'
			>
				<path
					id='Vector'
					d='M53.2165 78.0314C49.7659 81.0494 45.8788 86.3123 45.8788 86.3123C45.1788 85.1446 42.7165 84.8897 42.7165 84.8897C45.8129 82.6283 49.6753 76.8061 49.6753 76.8061C54.0894 69.6189 54.1882 61.9548 54.1882 50.845C54.1882 39.7353 52.22 31.9313 52.22 31.9313C52.22 31.9313 51.4047 34.168 43.3424 45.8617C35.28 57.5553 32.8835 68.7555 32.1177 72.6862C31.3518 76.617 31.2035 94.5768 31.2035 94.5768L30.4871 95.7281V64.8329C32.5047 59.4713 38.2612 52.7611 41.1353 48.2547C44.0177 43.7483 44.3718 39.1514 44.3718 39.1514C44.7341 34.1187 42.9306 25.8625 38.7553 19.7525C34.58 13.6426 31.0553 6.31557 30.9153 3.1578C30.7753 3.18289e-05 29.8365 0.353636 29.8365 0.353636C22.2106 10.9864 18.3235 32.0382 18.3235 32.0382C14.5188 28.239 7.05766 29.2423 4.27413 33.7487C2.40472 36.7749 1.6553 41.4211 3.22824 44.7022C3.55765 45.3847 4.02707 46.1248 4.58707 46.832C2.32236 45.6067 0.840005 44.9818 0.840005 44.9818C0.840005 44.9818 0.280006 49.0359 0.2553 49.4059C-0.107053 54.8909 0.428244 60.4499 1.2106 65.8773C2.0753 71.9132 5.62471 77.6367 9.84942 81.9951C15.6553 87.9899 22.2518 93.3186 28.8565 98.4171V104.667C25.4224 99.8562 25.3071 99.5272 20.1271 94.0669C14.9471 88.6066 0.840005 78.4015 0.840005 78.4015C1.31765 87.0031 2.1906 95.58 3.55765 104.083C4.22471 108.236 5.06472 112.537 7.30472 116.171C10.2612 120.974 15.68 124.551 20.3247 127.569C23.0835 129.37 25.1588 131.006 28.0988 132.511C26.6082 148.177 23.2977 161.753 23.2977 161.753C27.3247 162.115 30.4953 160.602 30.4953 160.602L30.4212 132.511C35.3871 130.644 42.1482 126.615 46.8259 122.092C51.5035 117.569 54.5259 109.083 55.1024 96.6573C55.6788 84.2236 53.2329 78.0479 53.2329 78.0479L53.2165 78.0314ZM28.8482 85.3584C28.8482 85.3584 28.2471 82.1266 27.2424 75.1532C26.2377 68.1798 22.2024 61.4285 22.2024 61.4285C18.5788 56.552 13.893 52.7364 9.83295 50.0062C17.2118 51.5111 21.1235 44.6117 21.1235 44.6117C22.9929 46.1166 28.8482 65.0221 28.8482 65.0221V85.3584ZM32.3482 119.707C32.3482 119.707 31.1047 120.949 30.4047 121.681V97.8579L32.4882 93.6887C32.1259 97.7099 36.5153 101.879 36.5153 101.879C33.6329 106.764 32.34 119.699 32.34 119.699L32.3482 119.707Z'
					fill={palette.secondary.main}
				/>
			</g>
			<defs>
				<clipPath id='clip0_83_727'>
					<rect
						width='56'
						height='162'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default Leaf;
